<template>
    <div class="container" v-if="YoukeMudidiDetailData">
        <Header status="simple"/>
        <div @click="$router.go(-1)" class="btn-icon back-btn">
            <div>
                <img src="../assets/back.png"/>
            </div>
            <div>返回客情</div>
        </div>

        <MapTitle :data="mapTitleData" @getCurTab="setCurtab"/>
        <div>
            <Transfermap v-if="curMap == 0"
                         :chartData="YoukeMudidiDetailData"
                         :legendColor="legendColor"
                         :title="YoukeMudidiDetailData.title"/>
            <AmapScatter :chartData="YoukeMudidiDetailCityData" :legendColor="legendColor" v-if="curMap == 1"/>


            <Linemap v-if="curMap == 2" :legendColor="legendColor" :legendConf="RemenLuxianDetailData.legendConf"
                     :lineData="RemenLuxianDetailData.lineData"/>


        </div>
        <div class="left-content" id="remenluxianTable">
            <BScroll>
                <RankBar v-if="curMap == 0 && YoukeMudidiDetailData"
                         :chartData="YoukeMudidiDetailData.sourceArea"
                         :lineNum="999"
                         id="youkelaiyuan-youkelaiyuan"
                         marginBottom="0.18rem"
                         rect="yes"
                />
                <RankBar v-if="curMap == 1 && YoukeMudidiDetailCityData"
                         :chartData="YoukeMudidiDetailCityData.sourceArea"
                         :lineNum="999"
                         id="youkelaiyuan-youkelaiyuan1"
                         marginBottom="0.18rem"
                         rect="yes"
                />

            </BScroll>
        </div>
        <div class="legend my-amap-legend">
            <div class="title">游客量</div>
            <ul>
                <li
                        :key="index"
                        v-for="(item, index) in YoukeMudidiDetailData.legendConf"
                >
                    <div class="rect">
                        <div
                                :style="{
                height: '0.05rem',
                background: legendColor[index],
                boxShadow: '0 0 5px ' + legendColor[index]
              }"
                                class="rect-in"
                        ></div>
                    </div>
                    <div class="num">
                        {{ item.max ? item.min + "-" + item.max : ">" + item.min }}
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import Header from "@/components/Common/Header.vue";
    import MapTitle from '@/components/Common/MapTitle.vue'
    import Transfermap from "@/components/Echarts/ChuyouTransfermap.vue";
    import AmapScatter from '@/components/Echarts/AmapScatter.vue'
    import BScroll from "@/components/Common/BScroll.vue";
    import RankBar from "@/components/Mycharts/ChuyouRankBar.vue";
    import Linemap from '@/components/Loca/Linemap.vue'


    export default {
        name: "ChuyouMudidi",
        components: {
            Header,
            MapTitle,
            Transfermap,
            AmapScatter,
            Linemap,
            BScroll,
            RankBar
        },
        data() {
            return {
                tableTab: 0,
                curMap: 0,
                panelFlag: true,
                YoukeMudidiDetailData: null,
                YoukeMudidiDetailCityData: null,
                RemenLuxianDetailData: null,
                mapTitleData: {
                    title: '',
                    tab: ['出游省', '出游城市', '省内出游关系']
                },
                legendColor: ["#DA221A", "#FF852F", "#F5E047", "#6BF15c", "#34B7ED"]
            };
        },
        mounted() {
            // 请求地图数据
            fetch("/data/JuminChuyou/JuminChuyouDetail.json")
                .then(response => {
                    return response.json();
                })
                .then(json => {
                    this.YoukeMudidiDetailData = json.data;
                    this.mapTitleData.title = json.data.title;
                });
            fetch("/data/JuminChuyou/JuminChuyouCityDetail.json")
                .then(response => {
                    return response.json();
                })
                .then(json => {
                    this.YoukeMudidiDetailCityData = json.data;
                });
            fetch("/data/JuminChuyou/shengneichuyouguanxi.json")
                .then(response => {
                    return response.json();
                })
                .then(json => {
                    this.RemenLuxianDetailData = json.data;
                });


        },
        methods: {
            setCurtab(val) {
                this.curMap = val;
            }
        }
    };
</script>
<style scoped lang="less">
    .container {
        .back-btn {
            left: 0.6rem;
            top: 0.8rem;
        }
        .left-content {
            width: 4.1rem;
            height: 84%;
            left: 0.6rem;
            top: 1.3rem !important;
            overflow: hidden;
            .rank-bar li {
                margin: 0 0 0.24rem;
            }
        }
    }
</style>
